export enum ContainerContentType {
    Section = 1,
    Widget = 2
}